import React from 'react'
import { filter, isEqual } from 'lodash'
import { connect } from 'react-redux'
import { selectCheckedoutPoll } from '../../../stores/pollBuilderCheckedoutPoll'
import {
  selectCustomerById,
  selectCustomerVerticals,
} from '../../../stores/customersStore'

import { Info, VerticalsContainer, Select } from './index.style'
import MenuRenderer from './MenuRenderer'
import OptionRenderer from './OptionRenderer'
import ValueRenderer from './ValueRenderer'

export class SiteVerticals extends React.Component {
  state = {
    selectedVerticals: [],
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { poll, customerConfig, customerVerticals } = this.props

    return (
      !isEqual(poll, nextProps.poll) ||
      !isEqual(customerVerticals, nextProps.customerVerticals) ||
      !isEqual(customerConfig, nextProps.customerConfig) ||
      !isEqual(nextState.selectedVerticals, this.state.selectedVerticals)
    )
  }

  componentDidUpdate(prevProps) {
    const { customerVerticals } = this.props

    if (!prevProps.customerVerticals.length && customerVerticals.length) {
      const selectedVerticals = this.getSelectedVerticals()
      this.setState({ selectedVerticals })

      const verticals = selectedVerticals.map(option => option.id)
      this.props.onChange(verticals)
    }
  }

  getSelectedVerticals = () => {
    const { poll, customerVerticals } = this.props
    if (poll.verticals && poll.verticals.length)
      return filter(customerVerticals, vertical =>
        poll.verticals.includes(vertical.id)
      )
    return filter(customerVerticals, { selected: true })
  }

  handleChange = options => {
    const verticals = options.map(option => option.id)
    this.props.onChange(verticals)
    this.setState({ selectedVerticals: options })
  }

  selectOnlyOneOption = option => {
    this.props.onChange([option.id])
    this.setState({ selectedVerticals: [option] })
  }

  render() {
    const { poll, customerConfig, customerVerticals } = this.props
    const { selectedVerticals } = this.state

    if (
      !poll.addToAutomationLibrary ||
      !customerConfig.enableVerticalTargeting ||
      customerVerticals.length < 1
    )
      return null

    const isValid = selectedVerticals && selectedVerticals.length

    return (
      <VerticalsContainer>
        <Select
          options={customerVerticals}
          multi={true}
          isValid={isValid}
          placeholder="Automated at: "
          labelKey="name"
          valueKey="id"
          closeOnSelect={false}
          clearable={false}
          value={selectedVerticals}
          removeSelected={false}
          onChange={this.handleChange}
          menuRenderer={MenuRenderer}
          valueComponent={ValueRenderer}
          optionRenderer={props => (
            <OptionRenderer
              {...props}
              selectedVerticals={selectedVerticals}
              selectOnlyOneOption={this.selectOnlyOneOption}
            />
          )}
        />
        <Info>The poll will be played out at the chosen verticals</Info>
      </VerticalsContainer>
    )
  }
}

const mapStateToProps = state => {
  const poll = selectCheckedoutPoll(state)
  return {
    poll: selectCheckedoutPoll(state),
    customerVerticals: selectCustomerVerticals(state),
    customerConfig: selectCustomerById(state, poll.customer),
  }
}

export default connect(
  mapStateToProps,
  {}
)(SiteVerticals)



// WEBPACK FOOTER //
// ./src/components/PollForm/VerticalTargeting/index.js